import { takeLatest, put, call } from 'redux-saga/effects';
import { toast } from 'react-toastify';
import isArray from 'lodash/isArray';
import { chrApi, phrApi, uploadDocuments } from '../../api/api';
import {
  INITIATE_APPOINTMENT_REPORTS_FETCH,
  FETCH_APPOINTMENT_REPORTS,
  INITIATE_GENERATE_REPORT,
  GET_FILE_URL,
  GENERATE_ENCOUNTER_REPORT,
  FETCH_APPOINTMENT_FAX_LOGS,
  FETCH_APPOINTMENT_FAX_LOGS_SUCCESS,
  PUT_MRR_FILES,
  FETCH_APPOINTMENTS,
  DOWNLOAD_ARCHIEVE,
  DOWNLOAD_S3_ACCESS_URL,
} from './Constants';
import { TOGGLE_LOADER, showLoader } from '../globalReducer';
import { apiErrorHandler } from '../Utils/apiErrorHandler';
import { FETCH_APPOINTMENTS_SUCCESS } from '../Home/constants';
import { fetchReportsByAppointmentId, fetchReportsByAppointmentIdSuccess } from './reducer';

export function getS3AccessUrlApi(keys) {
  return phrApi('post', 's3_access_url', {
    urls: isArray(keys) ? keys : [keys],
  });
}

function getAppointmentReportsApi(id) {
  return chrApi('get', `encounter/appointment/${id}`, null);
}
function* getAppointmentReports(action) {
  try {
    yield put(showLoader(true));
    const apiResponse = yield call(getAppointmentReportsApi, action.payload.appointmentId);
    yield put({ type: FETCH_APPOINTMENT_REPORTS, payload: apiResponse });
    yield put(showLoader(false));
  } catch (e) {
    yield call(apiErrorHandler, e);
  }
}

export function* fetchAppointmentReportsSaga() {
  yield takeLatest(INITIATE_APPOINTMENT_REPORTS_FETCH, getAppointmentReports);
}

function initiateGenerateReportApi(obj) {
  return chrApi('get', 'generate_report', null, obj,2);
}
function* initiateGenerateReport(action) {
  try {
    yield put({ type: TOGGLE_LOADER, payload: { status: false } });
    const {
      data: { reportUrl },
    } = yield call(initiateGenerateReportApi, action.payload.data);
    const apiResponse = yield call(getS3AccessUrlApi, reportUrl);
    yield put({ type: GET_FILE_URL, payload: apiResponse });
    yield put({ type: TOGGLE_LOADER, payload: { status: true } });
  } catch (e) {
    yield call(apiErrorHandler, e);
  }
}

export function* generateReportSaga() {
  yield takeLatest(INITIATE_GENERATE_REPORT, initiateGenerateReport);
}

function* getEncounterReport(action) {
  try {
    yield put({ type: TOGGLE_LOADER, payload: { status: false } });
    const {
      data: [obj],
    } = yield call(getAppointmentReportsApi, action.payload.appointmentId);
    const { templateId, formId, version } = obj;
    const data = {
      reportSourceType: 'Encounter',
      reportSourceId: action.payload.appointmentId,
      id: version === '2.0' ? templateId : formId,
      version,
    };
    yield put({ type: INITIATE_GENERATE_REPORT, payload: { data } });
    yield put({ type: TOGGLE_LOADER, payload: { status: true } });
  } catch (e) {
    yield call(apiErrorHandler, e);
  }
}

export function* generateEncounterReportSaga() {
  yield takeLatest(GENERATE_ENCOUNTER_REPORT, getEncounterReport);
}

function fetchFaxLogsByAppointmentApi(appointmentId) {
  return chrApi('get', `fax_log/appointment/${appointmentId}`, null, null);
}
function* fetchFaxLogsByAppointment(action) {
  try {
    yield put({ type: TOGGLE_LOADER, payload: { status: false } });
    const { data } = yield call(fetchFaxLogsByAppointmentApi, action.payload.appointmentId);
    yield put({ type: TOGGLE_LOADER, payload: { status: true } });
    yield put({ type: FETCH_APPOINTMENT_FAX_LOGS_SUCCESS, payload: { data } });
  } catch (e) {
    yield call(apiErrorHandler, e);
  }
}

export function* fetchFaxLogsByAppointmentSaga() {
  yield takeLatest(FETCH_APPOINTMENT_FAX_LOGS, fetchFaxLogsByAppointment);
}

function uploadMRRFilesApi({ encounterNoteId, mrrFileUrls }) {
  return chrApi('put', `encounter_note/mrr_files/${encounterNoteId}`, { mrrFileUrls }, null);
}

function uploadFilesApi(files) {
  const formData = new FormData();
  formData.append('path', 'MRRDocs');
  Array.from(files).map((file) => formData.append('file', file));
  return uploadDocuments('file_upload', formData);
}
function* uploadMRRFiles(action) {
  try {
    yield put({ type: TOGGLE_LOADER, payload: { status: false } });
    const { files, encounterNoteId } = action.payload;
    const { data } = yield call(uploadFilesApi, files);
    if (!encounterNoteId) {
      throw new Error('Encounter missing. Please report the error to Phypal');
    }
    yield call(uploadMRRFilesApi, {
      encounterNoteId,
      mrrFileUrls: data,
    });
    yield put({ type: TOGGLE_LOADER, payload: { status: true } });
    toast.success('MRR File Successfully Uploaded');
  } catch (e) {
    yield call(apiErrorHandler, e);
  }
}

export function* uploadMRRFilesSaga() {
  yield takeLatest(PUT_MRR_FILES, uploadMRRFiles);
}

function fetchAppointmentByDateApi({ practiceId, providerId, date }) {
  return chrApi('get', `appointment/practice/${practiceId}/provider/${providerId}/date/${date}`, null, null);
}
function* fetchAppointmentByDate(action) {
  try {
    const { practiceId, providerId } = action.payload;
    yield put({ type: TOGGLE_LOADER, payload: { status: false } });
    const apiResponse = yield call(fetchAppointmentByDateApi, action.payload);
    yield put({ type: TOGGLE_LOADER, payload: { status: true } });
    yield put({ type: FETCH_APPOINTMENTS_SUCCESS, payload: apiResponse });
  } catch (e) {
    yield call(apiErrorHandler, e);
  }
}

export function* fetchAppointmentByDateSaga() {
  yield takeLatest(FETCH_APPOINTMENTS, fetchAppointmentByDate);
}

function* downloadArchive(action) {
  try {
    const { archiveName, url, reportParamsList = [], reportS3Urls = [] } = action.payload;
    yield put({ type: TOGGLE_LOADER, payload: { status: false } });
    const { data } = yield call(() => chrApi('post', 'secure_share/archive_reports', { archiveName, reportS3Urls: url || reportS3Urls, reportParamsList }));
    yield put({ type: TOGGLE_LOADER, payload: { status: true } });
    const link = document.createElement('a');
    link.href = data.url;
    link.target = '_blank';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (e) {
    yield call(apiErrorHandler, e);
  }
}
export function* downloadArchiveSaga() {
  yield takeLatest(DOWNLOAD_ARCHIEVE, downloadArchive);
}

function getAppointmentReportsByIdApi(appointmentId) {
  return chrApi('get', `appointment/reports/${appointmentId}`, null, null);
}
function* getAppointmentReportsById(action) {
  try {
    yield put({ type: TOGGLE_LOADER, payload: { status: false } });
    const { data } = yield call(getAppointmentReportsByIdApi, action.payload);
    yield put({ type: TOGGLE_LOADER, payload: { status: true } });
    yield put(fetchReportsByAppointmentIdSuccess({ data }));
  } catch (e) {
    yield call(apiErrorHandler, e);
  }
}

export function* getAppointmentReportsByIdSaga() {
  yield takeLatest(fetchReportsByAppointmentId.type, getAppointmentReportsById);
}

function* _fetchS3AccessUrlApi(action) {
  try {
    yield put({ type: TOGGLE_LOADER, payload: { status: false } });
    const apiResponse = yield call(getS3AccessUrlApi, action.payload);
    yield put({ type: TOGGLE_LOADER, payload: { status: true } });
    yield put({ type: GET_FILE_URL, payload: apiResponse });
  } catch (e) {
    yield call(apiErrorHandler, e);
  }
}

export function* fetchS3AccessUrlSaga() {
  yield takeLatest(DOWNLOAD_S3_ACCESS_URL, _fetchS3AccessUrlApi);
}
